import type { AxiosInstance, AxiosResponse } from 'axios';
import type { IApiResponse } from '@/services';
import type { IApiResourceResponse } from '@/services/api/resource/types';
import { mapApiResource } from '@/mappers/resource';
import type { IResourceData } from '@/entities';

export * from './types';

export class ApiResourceEndpoint {
  axios: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axios = axiosInstance;
  }

  async fetchResource(): Promise<IResourceData[]> {
    const response: AxiosResponse<IApiResponse<IApiResourceResponse[]>> = await this.axios
      .get(`resources`)
      .catch(() => Promise.reject());

    if (response?.data.data) {
      return response.data.data.map((r) => mapApiResource(r));
    }

    return Promise.reject();
  }
}
